import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BackendManager from "../../templates/backend-manager.class";
import { DEFAULT_CURRENCY, DEFAULT_SHARED_API_BASE_URL } from "@lib/constants";
import { v4 as uuid } from 'uuid';
import APP_CONFIGURATION from "@lib/app.config";
import { isApiErrorResponse } from "types/shared/api-error";
import { permissionsManager } from "@lib/permissions/permissions-manager";
class CustomersManager extends BackendManager {
  constructor() {
    super((process.env.NEXT_PUBLIC_MUSCLE_SHARED_API_BASE_URL || DEFAULT_SHARED_API_BASE_URL) + "/customers");
    this.noAuthInterceptorManager = void 0;
    this.updateCardCVVToken = async (card_id, cvv_token) => {
      const route = "credit_cards/set_cvv_token";
      const requestBody = {
        cvv_token: cvv_token,
        id: card_id
      };
      try {
        const response = await super.getAxiosInstance().patch(route, requestBody);
        return response.data;
      } catch (error) {
        var _error$response;
        throw ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || error;
      }
    };
    this.updateDefaultFlag = async id => {
      const route = "credit_cards/".concat(id, "/set_default");
      try {
        const response = await super.getAxiosInstance().patch(route);
        return response.data;
      } catch (error) {
        var _error$response2;
        throw ((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) || error;
      }
    };
    this.sendResetPasswordEmail = async email => {
      const route = "passwords/send_forgot_email";
      const requestBody = {
        email: email
      };
      try {
        const response = await super.getAxiosInstance().post(route, requestBody);
        // TODO: Proper error handling
        return response.data;
      } catch (error) {
        return error.response.data;
      }
    };
    this.resetPassword = async (password, passwordConfirmation, resetPasswordToken) => {
      const route = "passwords/reset";
      const requestBody = {
        reset_token: resetPasswordToken,
        password: password,
        password_confirmation: passwordConfirmation
      };
      try {
        const response = await super.getAxiosInstance().put(route, requestBody);
        // TODO: Proper error handling
        return response.data;
      } catch (error) {
        throw error.response.data;
      }
    };
    this.deleteCard = async id => {
      const route = "credit_cards/".concat(id);
      try {
        const response = await super.getAxiosInstance().delete(route);
        return response.data;
      } catch (error) {
        var _error$response3;
        throw ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data) || error;
      }
    };
    /**
     * Interbank integration
     */
    this.getProviderToken = async () => {
      const route = "provider-token";
      try {
        const response = await super.getAxiosInstance().get(route);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }
    };
    this.callbackProvider = async (code, userId) => {
      const route = "callback-provider?code=".concat(encodeURIComponent(code), "&user_id=").concat(encodeURIComponent(userId));
      const isFromExpiredSession = localStorage.getItem('guest-access-token');
      try {
        const response = await this.noAuthInterceptorManager.getAxiosInstance().get(route, {
          headers: isFromExpiredSession ? {
            'Authorization': "Bearer ".concat(isFromExpiredSession),
            'X-Api-Key': isFromExpiredSession
          } : undefined
        });
        return response.data;
      } catch (error) {
        throw error.response.data;
      }
    };
    this.validateProviderSession = async () => {
      const demoMode = APP_CONFIGURATION.config.demo;
      if (demoMode) {
        return {
          message: "OK"
        };
      }
      const route = "validate-provider-session";
      try {
        const response = await this.noAuthInterceptorManager.getAxiosInstance().post(route);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }
    };
    this.noAuthInterceptorManager = new BackendManager((process.env.NEXT_PUBLIC_MUSCLE_SHARED_API_BASE_URL || DEFAULT_SHARED_API_BASE_URL) + "/customers", {
      allowAuthorizeInterceptor: false
    });
  }

  /**
   * Takes credentials and tries to log user in.
   * @param email (string) - user email
   * @param password (string) - user password
   * @returns (Customer | null) - The logged in customer if success, null if don't
   */
  async login(loginCustomer) {
    const allowGuestUserToken = permissionsManager.allowUnauthenticatedUsers();
    const loginModeJwt = process.env.NEXT_PUBLIC_LOGIN_MODE === 'token_param';
    const {
      email,
      password,
      guest_user_token,
      jwt
    } = loginCustomer;
    const requestBody = _objectSpread(_objectSpread(_objectSpread({}, email && password ? {
      email,
      password
    } : {}), allowGuestUserToken || loginModeJwt ? {
      guest_user_token
    } : {}), jwt ? {
      jwt
    } : {});
    const response = await this.noAuthInterceptorManager.getAxiosInstance().post("login", requestBody);
    return response.data;
  }
  async thirdPartyLogin(provider, access_token_provider, guest_user_token) {
    const requestBody = {
      provider,
      access_token_provider,
      guest_user_token: guest_user_token
    };
    const response = await this.noAuthInterceptorManager.getAxiosInstance().post("third_party_login", requestBody);
    return response.data;
  }
  /**
   * Gets the logged user using the authentication token header
   * @returns (Customer | null) - The logged in customer if success, null if don't
   */
  async getLoggedCustomer() {
    try {
      const res = await super.getAxiosInstance().get("");
      // TODO: Proper error handling
      if ("email" in res.data) {
        return res.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  /**
  * Gets a guest user token
  * @returns string - The guest user token
  */
  async getGuestCustomer() {
    var _localStorage$getItem;
    let guestUUID = localStorage.getItem('guest_id');
    const currentGuestAccessToken = localStorage.getItem('guest-access-token');

    // Has an existing guestUUID generated
    if (guestUUID && currentGuestAccessToken) {
      const validGuestTokenResponse = await this.noAuthInterceptorManager.getAxiosInstance().get('is-valid-token', {
        headers: {
          'Authorization': "Bearer ".concat(currentGuestAccessToken),
          'X-Api-Key': currentGuestAccessToken
        }
      });
      if (!isApiErrorResponse(validGuestTokenResponse.data)) {
        return validGuestTokenResponse.data;
      }
    } else if (!guestUUID) {
      guestUUID = uuid();
      localStorage.setItem('guest_id', guestUUID);
    }
    const newGuestTokenRequestBody = {
      uuid: guestUUID,
      currency_code: (_localStorage$getItem = localStorage.getItem('currency')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : DEFAULT_CURRENCY
    };

    // Generate a new access token for the guest user
    const newGuestTokenResponse = await super.getAxiosInstance().post('get_guest_customer', newGuestTokenRequestBody);
    return newGuestTokenResponse.data;
  }

  /**
   *  Register a user with third party provider
   * @param data
   * @returns
   */
  async registerThirdParty(data) {
    const guestUUID = localStorage.getItem('guest_id');
    if (!guestUUID) {
      return {
        error: 'Guest UUID not found'
      };
    }
    const requestBody = {
      provider: data.provider_id,
      access_token_provider: data.provider_token,
      uuid: guestUUID,
      first_name: data.first_name,
      last_name: data.last_name,
      addresses_attributes: [{
        country: data.country
      }],
      identification_number: data.identification_number
    };
    const response = await this.noAuthInterceptorManager.getAxiosInstance().post('register_third_party', requestBody);
    return response.data;
  }

  /**
  * Gets a guest user token
  * @returns string - The guest user token
  */
  async registerGuestUser(registerGuestUserDto) {
    let guestUUID = localStorage.getItem('guest_id');
    if (!guestUUID) {
      return {
        error: 'Guest UUID not found'
      };
    }
    const registerGuestUserBody = {
      uuid: guestUUID,
      first_name: registerGuestUserDto.first_name,
      last_name: registerGuestUserDto.last_name,
      addresses_attributes: [{
        country: registerGuestUserDto.country
      }],
      email: registerGuestUserDto.email,
      password: registerGuestUserDto.password,
      password_confirmation: registerGuestUserDto.password_confirmation,
      identification_number: registerGuestUserDto.identification_number,
      identification_type: "1"
    };
    const response = await super.getAxiosInstance().post('register_guest_customer', registerGuestUserBody);
    return response.data;
  }

  /**
   * Logs out the logged user
   * @returns true if logged out, false otherwise
   */
  async logout() {
    const route = "logout";
    try {
      const response = await super.getAxiosInstance().delete(route);
      // TODO: Proper error handling
      if ("error" in response.data) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  }

  /**
   * Fetches the logged user credit cards from the backend API using the authentication token header
   * @returns (CreditCard[]) - The saved credit cards for the logged user (if any)
   */
  async fetchSavedCreditCards() {
    const route = "credit_cards";
    const res = await super.getAxiosInstance().get(route);
    if (res.data.error) {
      return [];
    }
    return res.data;
  }

  /**
   * Saves a credit card for the logged user
   * @param creditCard (CreditCard) - The credit card to be saved
   * @returns (CreditCard) - The saved credit card
   */
  async saveCreditCard(creditCard) {
    const route = "credit_cards";
    try {
      const response = await super.getAxiosInstance().post(route, creditCard);
      return response.data;
    } catch (error) {
      var _error$response4;
      throw ((_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data) || error;
    }
  }
  async validateIdentificationForRegistration(identificationType, identification) {
    const route = "register/validate_id";
    const requestBody = {
      identification_type: identificationType,
      identification_number: identification
    };
    try {
      const response = await super.getAxiosInstance().post(route, requestBody);
      // TODO: Proper error handling
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
  async sendConfirmationInstructions(identificationType, identification) {
    const route = "register/send_confirmation_instructions";
    const requestBody = {
      identification_type: identificationType,
      identification_number: identification
    };
    try {
      const response = await super.getAxiosInstance().post(route, requestBody);
      // TODO: Proper error handling
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
  async registerConfirmation(confirmation_token) {
    const route = "register/confirm";
    const requestBody = {
      confirmation_token: confirmation_token
    };
    try {
      const response = await super.getAxiosInstance().post(route, requestBody);
      // TODO: Proper error handling
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
  async updateUserData(userData) {
    const route = "update_user_data";
    try {
      const response = await super.getAxiosInstance().put(route, userData);
      // TODO: Proper error handling
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
  async registerProviderCustomer(_ref) {
    let {
      email,
      email_confirmation,
      identification_type,
      identification_number,
      first_name,
      last_name,
      bank_uniq_id,
      oauth_provider,
      oauth_uid,
      country
    } = _ref;
    const res = await this.noAuthInterceptorManager.getAxiosInstance().post("/register-provider-user", {
      customer_user: {
        email,
        email_confirmation,
        identification_type,
        identification_number,
        first_name,
        last_name,
        bank_uniq_id,
        oauth_provider,
        oauth_uid,
        country,
        addresses_attributes: [{
          country
        }]
      }
    });
    return res.data;
  }
}
export default new CustomersManager();